module.exports = __webpack_public_path__ + "static/media/upload-kn.5281c9c5.svg";